import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

/**
 * Rewrites any navigation to `/group-order/...` to `/store/...`
 * and maps `groupOrderId` → `id` in the query string.
 */
export const v3LegacyGroupOrderPathRedirectGuard: CanActivateFn = (_route, state) => {
  const full = state.url;
  const hashIdx = full.indexOf('#');
  const pathWithQuery = hashIdx >= 0 ? full.slice(0, hashIdx) : full;
  const fragment = hashIdx >= 0 ? full.slice(hashIdx) : '';
  const [path, queryString = ''] = pathWithQuery.split('?');
  if (!path.startsWith('/group-order')) {
    return true;
  }
  const newPath = path.replace(/^\/group-order(?=\/|$)/, '/store');
  const sp = new URLSearchParams(queryString);
  if (sp.get('groupOrderId') && !sp.get('id')) {
    sp.set('id', sp.get('groupOrderId')!);
    sp.delete('groupOrderId');
  }
  const q = sp.toString();
  return inject(Router).parseUrl(newPath + (q ? '?' + q : '') + fragment);
};
